export default {
    '.level-3.two-col': {
        display: 'flex',
        WebkitBoxPack: 'center',
        msFlexPack: 'center',
        justifyContent: 'center',
        msFlexWrap: 'wrap',
        flexWrap: 'wrap',
        gap: '10px',
        maxWidth: '340px',
        margin: 0
    },

    'div[data-id="yr-philanthropy-shine-bright-do-good"], div[data-id="philanthropy-shine-bright-do-good"]':
        {
            margin: '20px 1rem',
            '.header': {
                fontFamily: 'var(--chakra-fonts-caslon)',
                color: 'var(--chakra-colors-black-100)',
                fontSize: '22px',
                fontWeight: 400,
                lineHeight: 'normal',
                letterSpacing: '.115px',
                textTransform: 'none',
                marginBottom: '10px'
            },
            '.description': {
                fontFamily: 'var(--chakra-fonts-inter)',
                color: 'var(--chakra-colors-black-100)',
                fontSize: '14px',
                fontWeight: 300,
                lineHeight: '22px',
                letterSpacing: '.07px',
                textTransform: 'none',
                margin: 0,
                a: {
                    textDecoration: 'underline',
                    textUnderlineOffset: '4px',
                    fontWeight: 400
                }
            }
        },

    '.level-2 .level-3': {
        marginBottom: '10px'
    },

    '.level-3.two-col li': {
        maxWidth: '48%'
    },

    '.full-img img': {
        maxWidth: '100%'
    },

    '.js-feature-slider': {
        display: 'flex',
        overflowX: 'auto',
        scrollSnapType: 'x mandatory',
        li: {
            flex: '0 0 40%',
            scrollSnapAlign: 'start',
            marginLeft: '10px'
        },
        a: {
            display: 'block',
            width: '100%',
            textAlign: 'left'
        }
    },

    '#category-nav li, #category-nav ul': {
        listStyleType: 'none',
        width: 'fit-content'
    },

    '.cat-item-0-expanded-yellowrose, .cat-item-0-expanded-kendrascott': {
        position: 'fixed',
        left: 0,
        top: '100px',
        backgroundColor: 'var(--chakra-colors-gray-50)',
        height: '100vh !important',
        width: '100vw',
        overflowY: 'overlay !important',
        display: 'block !important',
        paddingBottom: '180px',
        'li a': {
            fontSize: '.8125rem',
            transition: 'color 0.3s ease',
            '&:hover': {
                color: 'var(--chakra-colors-blue-700)'
            }
        }
    },

    '.basket-icon:hover .total-items': {
        background: 'var(--chakra-colors-gradientMinicartHover)',
        color: 'var(--chakra-colors-black)'
    },

    '.level-3-link, .level-3 a': {
        padding: 0,
        fontFamily: 'var(--chakra-fonts-inter)',
        letterSpacing: '.005em',
        color: 'var(--chakra-colors-black-100)',
        fontSize: '.8125rem',
        lineHeight: '22px',
        fontWeight: 300,
        textOverflow: 'ellipsis',
        overflow: 'hidden',
        display: '-webkit-box !important',
        WebkitBoxOrient: 'vertical',
        whiteSpace: 'normal',
        height: 'auto',
        marginTop: '5px'
    },

    '#category-nav .chakra-collapse .chakra-link, #category-nav .chakra-collapse .chakra-accordion, #category-nav .chakra-collapse .cat-acc-pannel':
        {
            paddingLeft: 0
        },

    '.child-category div[role=region]': {
        border: 'none !important',
        padding: '0 !important',
        margin: '0 !important'
    },

    '.acc-item-1 div[role=region], .custom-border-bottom': {
        padding: '0 0 20px 0',
        marginBottom: '20px'
    },

    '.custom-border-bottom': {
        borderBottom: '1px solid',
        borderImage:
            'linear-gradient(270deg, var(--chakra-colors-gray-450) 60%, var(--chakra-colors-gray-800)) 1'
    },

    '.acc-item-1 div[role=region]:after': {
        content: "''",
        display: 'block',
        position: 'absolute',
        marginTop: '20px',
        marginLeft: '30px',
        width: 'calc(100% - 60px)',
        height: '1px',
        borderBottom: '1px solid',
        borderImage:
            'linear-gradient(270deg, var(--chakra-colors-gray-450) 60%, var(--chakra-colors-gray-800)) 1'
    },

    '.acc-item-2 div[role=region]': {
        display: 'none'
    },

    // Loyalty Callout Styles
    '.loyalty-callouts-wrapper': {
        '.callout__content': {
            fontWeight: 300,
            color: 'var(--chakra-colors-black-100)',
            fontSize: '14px',
            fontFamily: 'var(--chakra-fonts-inter)'
        },
        '.birthday-promo-25, .birthday-promo-50': {
            '.callout__content': {
                padding: '15px 30px',
                background: 'var(--chakra-colors-gray-100)',
                border: '1px solid',
                borderColor: 'var(--chakra-colors-gray-450)',
                borderRadius: '10px'
            }
        },
        '.emp': {
            fontWeight: 400
        }
    }
}
